export const docType = [
  "doc",
  "docx",
  "xlsx",
  "xls",
  "pdf",
  "rar",
  "zip",
  "jpg",
  "jpeg",
  "png",
  "odt",
  "tiff",
];
